import { useLocation, Link } from "react-router-dom";
import { useMemo } from "react";
import { motion } from "framer-motion";
import "./Breadcrumbs.css";

const breadcrumbNameMap = {
  dashboard:      "Dashboard",
  Membership:     "Membership",
  MembershipForm: "Membership Form",
  Profile:        "My Profile",
  profile:        "My Profile",
  Business_impact:"Business Impact",
  Businessimpact: "Business Wallet",
  WithdrawalForm: "Withdrawal Request",
  new_request:    "New Request",
  sent_request:   "Sent Request",
  receive_request:"Receive Request",
  accept_request: "Accept Request",
  member:         "Members",
  Timeline:       "Timeline",
  user:           "User Directory",
  news:           "News",
  newsArticle:    "News Article",
  photosgallery:  "Photo Gallery",
  albumCard:      "Albums",
  albumsgallery:  "Albums Gallery",
  videosgallery:  "Videos",
  EventsMenu:     "Events",
  EventRegistration: "Event Registration",
  EventsCards:    "Event Cards",
  Events:         "Events",
  certificates:   "Certificates",
  OtherProfile:   "Other Profile",
  chat:           "Chat",
  recentMember:   "Recent Members",
  "upload-invoices": "Upload Invoice",
  invoicelist:    "Invoice List",
  Help:           "Help",
  activeMember:   "Active Members",
  memberinCountry:"Members by Country",
};

const pageIcons = {
  dashboard:      "bx bx-home-circle",
  Membership:     "bx bx-id-card",
  Business_impact:"bx bx-trending-up",
  Businessimpact: "bx bx-wallet",
  WithdrawalForm: "bx bx-money-withdraw",
  new_request:    "bx bx-plus-circle",
  sent_request:   "bx bx-send",
  receive_request:"bx bx-inbox",
  accept_request: "bx bx-check-circle",
  Timeline:       "bx bx-time-five",
  user:           "bx bx-group",
  news:           "bx bx-news",
  EventsMenu:     "bx bx-calendar-event",
  certificates:   "bx bx-award",
  chat:           "bx bx-chat",
  profile:        "bx bx-user-circle",
  "upload-invoices": "bx bx-upload",
  invoicelist:    "bx bx-receipt",
  Help:           "bx bx-info-circle",
  recentMember:   "bx bx-user-plus",
};

const Breadcrumbs = () => {
  const location = useLocation();

  const currentPathnames = location.pathname.split("/").filter(Boolean);
  const fromPath = location.state?.from?.split("/").filter(Boolean) || [];

  const breadcrumbs = useMemo(() => {
    const items = [];
    items.push({ label: "Home", to: "/dashboard", icon: "bx bx-home-alt-2" });

    for (let i = 0; i < fromPath.length; i++) {
      const part = fromPath[i];
      const to = "/" + fromPath.slice(0, i + 1).join("/");
      if (!items.find((x) => x.to === to)) {
        items.push({ label: breadcrumbNameMap[part] || part, to, icon: pageIcons[part] });
      }
    }

    for (let i = 0; i < currentPathnames.length; i++) {
      const part = currentPathnames[i];
      const to = "/" + currentPathnames.slice(0, i + 1).join("/");
      if (!items.find((x) => x.to === to)) {
        items.push({
          label: breadcrumbNameMap[part] || part,
          to,
          icon: pageIcons[part],
          isLast: i === currentPathnames.length - 1,
        });
      }
    }

    // mark last
    if (items.length) items[items.length - 1].isLast = true;

    return items;
  }, [location]);

  const lastItem = breadcrumbs[breadcrumbs.length - 1];

  return (
    <motion.div className="bc-wrap"
      style={{ textAlign: "left", alignItems: "flex-start" }}
      initial={{ opacity:0, y:-10 }}
      animate={{ opacity:1, y:0 }}
      transition={{ duration:.35, ease:[.22,.68,0,1.2] }}>

      {/* single compact row: icon + title + separator + trail */}
      <div className="bc-row">
        {lastItem?.icon && (
          <motion.span className="bc-page-icon"
            initial={{ scale:.7, opacity:0 }}
            animate={{ scale:1, opacity:1 }}
            transition={{ type:"spring", stiffness:300, damping:18, delay:.08 }}>
            <i className={lastItem.icon}></i>
          </motion.span>
        )}
        <h1 className="bc-page-title">{lastItem?.label}</h1>

        <span className="bc-row-sep"><i className="bx bx-chevron-right"></i></span>

        <nav aria-label="breadcrumb">
          <ol className="bc-list">
            {breadcrumbs.map(({ label, to, icon, isLast }, idx) => (
              <motion.li key={to + idx}
                className={`bc-item ${isLast ? "bc-current" : ""}`}
                initial={{ opacity:0, x:-8 }}
                animate={{ opacity:1, x:0 }}
                transition={{ duration:.28, delay: idx * 0.06 }}>
                {!isLast ? (
                  <>
                    <Link to={to} className="bc-link">
                      {icon && <i className={icon}></i>}
                      <span>{label}</span>
                    </Link>
                    <span className="bc-sep"><i className="bx bx-chevron-right"></i></span>
                  </>
                ) : (
                  <span className="bc-active">
                    {icon && <i className={icon}></i>}
                    <span>{label}</span>
                  </span>
                )}
              </motion.li>
            ))}
          </ol>
        </nav>
      </div>
    </motion.div>
  );
};

export default Breadcrumbs;
